/* global axios */
import ApiClient from '../ApiClient';

class CopilotAuditEvents extends ApiClient {
  constructor() {
    super('copilot/audit_events', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new CopilotAuditEvents();
